var map = {
	"./icon-stats-certificates.svg": 1482,
	"./icon-stats-courses.svg": 1483,
	"./icon-stats-exercises.svg": 1484,
	"./icon-stats-instructors.svg": 1485,
	"./icon-stats-projects.svg": 1486,
	"./icon-stats-rating.svg": 1487,
	"./icon-stats-reviews.svg": 1488,
	"./icon-stats-students.svg": 1489,
	"./icon-stats-video.svg": 1490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1618;